import React from "react";
import { renderLayout } from "schema/ThemeSet.react";
import InputField from "slides/components/InputField.react";

export default class FillInTheBlank extends React.Component {
    handleClick = (answer) => {
        this.props.trackInteraction(answer);
    };

    render() {
        let isPortrait =
            this.props.mobileView || window.innerHeight > window.innerWidth;
        let LayoutRender = renderLayout(isPortrait, this.props.layout);
        let answer = this.props.data.answer
            .toString()
            .trim()
            .replace(/[a-z0-9&_]/gi, "*");

        return (
            <div className="full-height">
                <LayoutRender
                    {...this.props}
                    title={"Let us know:"}
                    mainContent={
                        <InputField
                            {...this.props}
                            placeholder={answer}
                            handleClick={this.handleClick}
                            smallField={true}
                        />
                    }
                />
            </div>
        );
    }
}
